import { TextField } from "@mui/material";
import { FC } from "react";

interface Props {
  onChange: (values: { start_date: string; end_date: string }) => void;
  values: { start_date: string; end_date: string };
}

const Filters: FC<Props> = ({ onChange, values }) => {
  return (
    <form
      className="flex gap-4 mb-4"
      onSubmit={(e) => {
        e.preventDefault();
        onChange(values);
      }}
    >
      <TextField
        type="date"
        value={values.start_date}
        onChange={(e) => onChange({ ...values, start_date: e.target.value })}
      />
      <TextField
        type="date"
        value={values.end_date}
        onChange={(e) => onChange({ ...values, end_date: e.target.value })}
      />
      <button className="px-2 bg-blue-600 text-white rounded">Filtrar</button>
    </form>
  );
};

export default Filters;
